import axios from 'axios';
import * as React from 'react';
import API from 'lib/RemindAPI';
import toPairs from 'lodash/toPairs';
import { PickFile } from './Picker';
import { dataURItoBlob } from './lib/dataURItoBlob';

type Props = {
  file: PickFile;
  // Adds access controls to the file.
  // At time of writing this, only the owner will be able to see the file
  private?: boolean;
  children: (args: {
    url?: string;
    progress?: number;
    fileType?: string;
    thumbnail?: string;
  }) => React.ReactNode;
  onUploadSuccess?: Function;
  onUploadSuccess2?: Function;
};

type State = {
  url?: string;
  progress?: number;
  fileType?: string;
  thumbnail?: string;
};

type FileFormField = [string, Blob];

export function buildForm(fields: FileFormField, blob: Blob) {
  const form = new FormData();
  const filePair: FileFormField = ['file', blob];
  const data = [...toPairs(fields), filePair];
  data.forEach(pair => form.append(pair[0], pair[1]));
  return form;
}

class Uploader extends React.Component<Props, State> {
  state: State = {};

  componentDidMount() {
    this.uploadFile(this.props.file);
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.file.dataURI !== this.props.file.dataURI) {
      this.uploadFile(this.props.file);
    }
  }

  async uploadFile(file: PickFile) {
    this.setState({ progress: 0, url: undefined });

    const data = await API.request('/files', 'POST', {
      file: { name: file.name },
      private: !!this.props.private,
    });

    const fileUuid = data.id;
    const blob = dataURItoBlob(file.dataURI);
    const form = buildForm(data.fields, blob);
    const fileType = data.fields['Content-Type'];
    const thumbnail = fileType && fileType.startsWith('image') ? file.dataURI : undefined;
    this.setState({ fileType, thumbnail });

    await axios.post(data.upload_url, form, {
      onUploadProgress: progressEvent => {
        this.setState({ progress: (progressEvent.loaded / progressEvent.total) * 100 });
      },
    });

    const fileAckData = await API.request(`/files/${fileUuid}/ack`, 'POST');
    const url = fileAckData.urls.cdn;

    this.setState({ url });

    if (this.props.onUploadSuccess) {
      this.props.onUploadSuccess(data);
    }

    if (this.props.onUploadSuccess2) {
      this.props.onUploadSuccess2({ data, url });
    }
  }

  render() {
    return this.props.children({
      progress: this.state.progress,
      url: this.state.url,
      fileType: this.state.fileType,
      thumbnail: this.state.thumbnail,
    });
  }
}

export default Uploader;
